import { useState } from 'react';
import { ADMIN_USERNAME_MAX, useAdminSession } from '../../data/useAdminSession';
import './LoginForm.css';

function LoginForm({ onSignedIn }) {
  const { check, login } = useAdminSession();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [problem, setProblem] = useState('');

  async function submit(event) {
    event.preventDefault();
    setProblem('');
    setBusy(true);
    try {
      await login(username, password);
      await check();
      onSignedIn?.();
    } catch (error) {
      // A username that cannot be the admin one stays in the field so it can be corrected.
      if (error.code !== 'bad-admin-username-typed') setUsername('');
      setPassword('');
      setProblem(error.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="login" onSubmit={submit}>
      <div className="login__field">
        <label className="login__label" htmlFor="admin-username">
          Admin username
        </label>
        <input
          id="admin-username"
          className="login__input"
          type="text"
          value={username}
          onChange={(event) => {
            setUsername(event.target.value);
            setProblem('');
          }}
          autoComplete="username"
          autoCapitalize="none"
          spellCheck="false"
          maxLength={ADMIN_USERNAME_MAX}
          required
        />
      </div>

      <div className="login__field">
        <label className="login__label" htmlFor="admin-password">
          Password
        </label>
        <input
          id="admin-password"
          className="login__input"
          type="password"
          value={password}
          onChange={(event) => {
            setPassword(event.target.value);
            setProblem('');
          }}
          autoComplete="current-password"
          maxLength="200"
          required
        />
      </div>

      {problem && (
        <p className="login__problem" role="alert">
          {problem}
        </p>
      )}

      <button type="submit" className="btn" disabled={busy}>
        {busy ? 'Checking' : 'Sign in'}
      </button>
    </form>
  );
}

export default LoginForm;
